<div class="grid-table">
  <div class="grid-table-header"
       [ngClass]="{'grid-auto-1': allowMultiSelection}">
    <ng-container *ngIf="allowMultiSelection">
      <div class="selectall"><i class="md-btn-circular far fa-check-double" (click)="selectAll(!_selectState)"></i></div>
    </ng-container>
    <div [class]="containerClass">
      <div *ngFor="let header of uiSort; index as i"
           class="span-{{header.span}} grid-table-sortheader"
           (click)="toggleSearchValue(i)">
        <span>{{header.uiCaption}}</span>
        <i class="fas" [ngClass]="{
                      'grid-table-sortheader-icon-inactive': header.uiValue == 0
                      ,'fa-arrow-up'    : header.uiValue == 1 || header.uiValue == 0
                      ,'fa-arrow-down'  : header.uiValue == 2 }"></i>
      </div>
    </div>
  </div>
  <div class="grid-table-body"  *ngIf="displayState==0">
    <ng-container *ngFor="let row of rowSource; index as i">
      <div class="grid-table-row grid" [ngClass]="{'grid-auto-1': allowMultiSelection, 'active': selectedRow==i && allowSingleSelection}" (click)="selectedRow=i" (dblclick)="onDblClick(i)">
        <ng-container *ngIf="allowMultiSelection"><exg-checkbox [tiny]="true" [ngModel]="isSelected(i)" (click)="selectClick($event,i)"></exg-checkbox> </ng-container>
        <div [class]="containerClass">
          <ng-container *ngTemplateOutlet="rowTemplate; context: {$implicit: row}"></ng-container>
        </div>
      </div>
    </ng-container>
  </div>
  <div class="content" *ngIf="displayState==1"><div class="splash loading"><div class="spinner"><div></div><div></div><div></div><div></div></div></div></div>
  <div class="content" *ngIf="displayState==2"><div class="splash empty"><p>{{displayStateMessage}}</p></div></div>
</div>

